<template>
  <div class="w-full d-flex flex-wrap pa-3">
    <OCapCont class="w-full pa-3" label="Senha atualizada em">
      {{ value.passwordUpdatedAt | moment('YYYY-MM-DD HH:mm') }}
    </OCapCont>

    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="reset">Resetar senha</v-btn>
    </div>
  </div>
</template>

<script>
import { OrgApi } from '@/models/index.js'
import utils from 'oderon-commons/src/utils.js'

export default {
  props: {
    value: { required: true }
  },
  methods: {
    async reset() {
      let newPassword = await this.$prompt({
        label: 'Digite a nova senha',
        value: ''
      })

      if (newPassword == null) {
        // foi cancelado, não faz nada
      } else if (utils.isEmpty(newPassword)) {
        // clicou ok sem digitar nada (ou apenas espaços)
        this.$snack('Senha vazia não é permitida', { color: 'red' })
      } else {
        // digitou uma senha ok
        this.$rootLoading(async () => {
          let fetcher = new OrgApi(this.value.orgId)
          let body = { newPassword }
          await fetcher.put(`users/${this.value.id}/password`, body)
          this.$snack('Salvo com sucesso')
          this.$emit('reload')
        })
      }
    }
  }
}
</script>

<style></style>
